var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map--wrap"},[(_vm.title)?_c('div',{staticClass:"google-map--title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{ref:"googleMap",staticClass:"google-map--basic"})])
}
var staticRenderFns = []

export { render, staticRenderFns }